import { ReactNode } from 'react'
import { List } from '@mui/material'

import { useStyles } from './styles'

interface IProps {
  children: ReactNode
  fullWidth?: boolean
}

export const AssociationsListWrapper = ({ children, fullWidth }: IProps) => {
  const classes = useStyles({ fullWidth })

  return (
    <List className={classes.listWrapper} disablePadding>
      {children}
    </List>
  )
}
